import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { PageView } from '@jg/react-tracking';
import Helmet from 'react-helmet';

import JoinStepNavigationContainer from '../JoinStepNaviagtionContainer/JoinStepNaviagtionContainer';
import Divider from '../../components/Divider/Divider';
import CreateEvent from '../../components/CreateEvent/CreateEvent';

type CreateEventProps = {
  switchToSelectMode: () => void;
};

export const CreateEventPage: FunctionComponent<CreateEventProps> = ({
  switchToSelectMode,
}) => {
  const { t } = useTranslation();

  return (
    <PageView
      trackingData={{
        subtype: 'join team',
        event_value: 'create consumer event',
        page_section: 'join team > create event',
      }}
    >
      <Helmet title={t('title.join.createEvent')} />
      <main data-qa="create-event-page" className="jg-space-pbxl">
        <JoinStepNavigationContainer />
        <h1 className="jg-text--center jg-space-mbmd">
          {t('content.selectEvent.heading')}
        </h1>
        <p className="jg-text--center">
          <button
            type="button"
            className="jg-text--link jg-cursor-pointer jg-btn--transparent"
            data-qa="search-event-button"
            onClick={switchToSelectMode}
          >
            {t('content.createEvent.searchForOrganisedEvent')}
          </button>
        </p>
        <Divider className="jg-space-mvml">{t('global.or')}</Divider>
        <CreateEvent />
      </main>
    </PageView>
  );
};

export default CreateEventPage;
